import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, ResolveFn } from '@angular/router';
import { PretRecouvrementService } from '../../services/pret-recouvrement.service';
import { DetailsPretResponse } from '../../interfaces/pret-recouvrement.interface';

export const detailCreditResolver: ResolveFn<DetailsPretResponse> = (route: ActivatedRouteSnapshot) => {
  const numDossier = route.paramMap.get('numDossier');
  return inject(PretRecouvrementService).getPretDetail(numDossier);
};
